export default "__VITE_ASSET__Dp7WH85A__"